import {useReservation} from 'context/reservation';
import {usePaymentsCart, useOrderHistory} from 'hooks';
import {useFetchReservationPayments} from 'hooks/payments/useFetchReservationPayments';
import {checkIfTotalAmountToPayZero} from 'utils/payments';

function useBuildPaymentItem() {
  const {
    paymentsCart,
    isPaymentsCartLoading,
    isPaymentsCartFetching,
    isPaymentsCartEmpty,
  } = usePaymentsCart({refetchOnWindowFocus: true});
  const {reservationId} = useReservation();
  const {data: reservationPayments, isFetching: isReservationPaymentsFetching} =
    useFetchReservationPayments({reservationId});

  const {orderHistory, isOrderHistoryFetching} = useOrderHistory();

  const totalFee =
    parseFloat(paymentsCart?.total_amount_to_pay || '0') -
    parseFloat(paymentsCart?.amount || '0');

  const isLoading =
    isPaymentsCartLoading ||
    isPaymentsCartFetching ||
    isOrderHistoryFetching ||
    isReservationPaymentsFetching;
  const isTotalAmountToPayZero = checkIfTotalAmountToPayZero(paymentsCart);

  return {
    isLoading,
    isPaymentsCartEmpty,
    paymentsCart,
    totalToPay: orderHistory?.payment_details
      ?.reduce((sum, order) => sum + parseFloat(order.total_amount_with_commission || '0'), 0)
      .toFixed(2),
    totalFee: totalFee.toFixed(2),
    isTotalAmountToPayZero,
    items: reservationPayments?.filter(payment => !payment.hidden) || [],
  };
}

export {useBuildPaymentItem};
